import { render, staticRenderFns } from "./RevokeCertModal.vue?vue&type=template&id=46ca6373"
import script from "./RevokeCertModal.vue?vue&type=script&lang=js"
export * from "./RevokeCertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports